import { render } from "./dlg-task.vue?vue&type=template&id=0cbecce2"
import script from "./dlg-task.vue?vue&type=script&lang=js"
export * from "./dlg-task.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__